import { ClinicalTrialList } from '@components/LoginSelections/ClinicalTrialList/ClinicalTrialList';
import { ClinicalTrialAffiliatesType } from '@dynamika-shared/types/clinicalTrialAffiliates';
import { routesPath } from '@router/routes';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { useClinicalTrialAffiliatesSlice } from '@restore/clinicalTrialAffiliates/clinicalTrialAffiliates.slice';
import { Divider } from 'antd';
import { useSettingsSlice } from '@restore/settings/settings.slice';
import { useFeatureFlag } from '@dynamika-shared/services/featureFlags';
import { renderSiteMenuSections } from './siteRoutes';
import { prepareUrl } from '@utils/routerHelpers';

export const SiteUserMenu = () => {
  const { id: clinicalTrialId } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarCollapsed = useSettingsSlice(state => state.sidebarCollapsed);
  const { QUERY_MANAGEMENT_FLAG } = useFeatureFlag();

  const [dataCT, fetchClinicalTrialAffiliates] =
    useClinicalTrialAffiliatesSlice((state, actions) => [
      state.data,
      actions.fetchClinicalTrialAffiliates,
    ]);
  const [fetchContext, data] = useClinicalTrialContextSlice(
    (state, actions) => [actions.fetchClinicalTrialContext, state.data]
  );

  useEffect(() => {
    if (clinicalTrialId && clinicalTrialId !== data?.configuration.id) {
      fetchContext(clinicalTrialId);
    }
  }, [clinicalTrialId, data?.configuration.id]);

  useEffect(() => {
    if (!dataCT.length) {
      fetchClinicalTrialAffiliates(null);
    }
  }, [dataCT]);

  const handleSelectCT = (clinicalTrial: ClinicalTrialAffiliatesType) => {
    if (QUERY_MANAGEMENT_FLAG) {
      const isQueriesRoute = location.pathname.includes('/subject/queries');
      const target = isQueriesRoute
        ? prepareUrl(routesPath.subjectQueries, [clinicalTrial.id])
        : prepareUrl(routesPath.subject, [clinicalTrial.id]);
      navigate(target);
      return;
    }
    navigate(`${routesPath.subjectBase}/${clinicalTrial.id}`);
  };

  return (
    <div>
      {QUERY_MANAGEMENT_FLAG && (
        <>
          <ul className='list-none m-0 p-0'>
            {renderSiteMenuSections(clinicalTrialId, sidebarCollapsed)}
          </ul>
          <Divider />
        </>
      )}

      <ClinicalTrialList
        clinicalTrials={dataCT}
        handleSelectCT={handleSelectCT}
        context={'menu'}
      />
    </div>
  );
};
